import { Cartao } from "@plantus/ui";
import type { Lote } from "@plantus/api-client";

import { DadosDoLote } from "./DadosDoLote";

/**
 * A aba **Resumo** — o que o lote é, e o que se pode fazer com ele.
 *
 * <h2>Os dois cartões ficam LADO A LADO onde o painel comporta, e o JSX não
 * sabe disso</h2>
 *
 * <p>Não há prop, condição nem medição aqui: quem decide é
 * `@container painel-do-lote (min-width: 52rem)` em `app.css`, pela mesma
 * razão da aba de etiquetas — a pergunta <i>"cabem duas colunas?"</i> se
 * responde com a largura do <b>painel</b>, que depende de a lateral estar
 * esticada ou recolhida, e não com a largura da janela.
 *
 * <p>O que importa saber ao mexer neste arquivo é que <b>a ordem dos dois
 * `Cartao` é a ordem das colunas</b>: o primeiro é PROSA e recebe o teto de
 * leitura, o segundo é FICHA e vale o que os pares pedem. Trocá-los de lugar
 * troca os tetos. Medido em 2026-08-14: com o teto de prosa aplicado à ficha,
 * 358px separavam "Validade" de "13/08/2028" — 70% da largura do bloco. Ver
 * docs/features/7-nucleo-e-experiencia/7.2-responsividade/7.2.2.
 *
 * <h2>Por que o selo de situação NÃO se repete aqui</h2>
 *
 * <p>Ele está no cabeçalho do lote, algumas linhas acima, em toda aba — é a
 * decisão do PO na #36 ("código, empresa e situação sempre à vista"). Repeti-lo
 * dentro do cartão poria o mesmo selo duas vezes na mesma tela, e dois selos
 * iguais separados por meia dobra ensinam a duvidar de qual dos dois é o atual.
 *
 * <p>O que **não** está no cabeçalho é a <b>consequência em palavras</b>, e é
 * ela que fica aqui: o selo diz o estado, e o que decide o trabalho é o que se
 * pode <b>fazer</b> com o material. É a mesma R5 da ficha do volume, no lugar
 * onde ela ainda é a única coisa dita.
 */
export function AbaResumo({ lote }: { lote: Lote }) {
  return (
    <div className="lote">
      <Cartao titulo="Situação atual">
        <h2 className="lote__rotulo-secao">Situação atual</h2>
        <p className="lote__consequencia">
          {lote.situacao === "APROVADO"
            ? "Liberado pela qualidade — pode ser usado."
            : "Não pode ser usado até a liberação da qualidade."}
        </p>
        <p className="lote__agora">
          É a situação de <strong>agora</strong>, lida do sistema. A etiqueta
          colada no tambor não afirma situação nenhuma, de propósito: ela não é
          trocada quando o lote muda de estado.
        </p>
      </Cartao>

      <Cartao titulo="O lote">
        <h2 className="lote__rotulo-secao">O lote</h2>
        <DadosDoLote lote={lote} />
      </Cartao>
    </div>
  );
}
